import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TEAMS_TEAM_LINEUPS_DELETE_FETCH = 'TEAMS_TEAM_LINEUPS_DELETE_FETCH'
export const TEAMS_TEAM_LINEUPS_DELETE_FETCH_CANCELED = 'TEAMS_TEAM_LINEUPS_DELETE_FETCH_CANCELED'
export const TEAMS_TEAM_LINEUPS_DELETE_FETCH_ERROR = 'TEAMS_TEAM_LINEUPS_DELETE_FETCH_ERROR'
export const TEAMS_TEAM_LINEUPS_DELETE_FETCH_FULFILLED = 'TEAMS_TEAM_LINEUPS_DELETE_FETCH_FULFILLED'

export const teamLineupsDeleteFetch = (teamId, lineupId) => ({
  payload: { lineupId, teamId },
  type: TEAMS_TEAM_LINEUPS_DELETE_FETCH,
})

export const teamLineupsDeleteFetchFulfilled = (payload) => ({
  payload,
  type: TEAMS_TEAM_LINEUPS_DELETE_FETCH_FULFILLED,
})

export const teamLineupsDeleteFetchCanceled = () => ({
  payload: null,
  type: TEAMS_TEAM_LINEUPS_DELETE_FETCH_CANCELED,
})

export const teamLineupsDeleteFetchError = (payload) => ({
  payload,
  type: TEAMS_TEAM_LINEUPS_DELETE_FETCH_ERROR,
})

export const teamLineupsDeleteFetchEpic = (action$) =>
  action$.pipe(
    ofType(TEAMS_TEAM_LINEUPS_DELETE_FETCH),
    mergeMap((action) =>
      epicServerRequest(
        'delete',
        `${APP.api_url}/sports/soccer/team/${action.payload.teamId}/lineup/${action.payload.lineupId}`,
        action,
      ).pipe(
        map(epicResponseHandler(teamLineupsDeleteFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TEAMS_TEAM_LINEUPS_DELETE_FETCH, TEAMS_TEAM_LINEUPS_DELETE_FETCH_CANCELED))),
        catchError(epicErrorHandler(teamLineupsDeleteFetchError, action)),
      ),
    ),
  )
